          <div class="search-container nav-search-container header-button">
            <input placeholder="Search..." [style.color]="headerTextColor" type="text" #search class="nav-search" [formControl]="searchInput"
              [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)"
              [displayWith]="createDisplayFn">
              <mat-optgroup *ngFor="let searchResItem of groupedSearchResults | keyvalue">
                <mat-icon matIcon class="header-search-result-icon" svgIcon="{{searchResItem.key.toLowerCase()}}">
                  {{searchResItem.key.toLowerCase()}}</mat-icon>
                {{searchResItem.key}}

                <mat-option *ngFor="let entityItem of searchResItem.value" [value]="entityItem.entityName"
                  [id]="entityItem.entityType + '-|-' + entityItem.entityId" [disabled]="isErrorMessage(entityItem)">
                  <ng-container *ngFor="let pathPart of entityItem.path; let i = index">
                    {{pathPart}} <span *ngIf="i !== (entityItem.path.length -1)"
                      class="auto-complete-path-separator">/</span>
                  </ng-container>
                </mat-option>
              </mat-optgroup>
            </mat-autocomplete>
          </div>
